var WireTransferRequest = function() {
	var comp = $('[data-component="wire-transfer-request"]');

	function init() {
		addListeners();
		formValidate();
	}

	function addListeners() {
		comp.find('.change-password').on('click', function(e) {
			e.preventDefault();
			if (comp.find('#formStep1').valid()) {
				comp.find('#formStep1').trigger('submit');
			}
		});

		// Limpa todos os inputs
		comp.find('.clear').on('click', function(e) {
			e.preventDefault();
			comp.find('#formStep1').get(0).reset();
		});
	}

	// Define os campos a serem validados
	function formValidate() {
		comp.find('#formTransferRequest').validate({
			rules: {
				"accountNumber": "required",
				"amount": {
					"required": true,
					"number": true
				},
				"bankAbaNumber": "number",
				"value-date": "required",
				"bankName": "required",
				"bankState": "required",
				"bankCity": "required"
			}
		});
	}

	return init();
}

$(document).ready(function() {
	if ($('[data-component="wire-transfer-request"]').length > 0) {
		new WireTransferRequest();
	}
});
